import { CheckOutlined, CloseOutlined, SendOutlined } from '@ant-design/icons';
import type { ModalProps } from 'antd';
import { Button, Card, Modal, Spin } from 'antd';
import cn from 'classnames';

import { useSendNotificationsMutation } from '@/api/endpoints/schools/schoolSelectionPanel';
import { getRussianPluralForm } from '@/shared/helpers';
import { useApiRequest } from '@/shared/hooks';

import styles from './SendNotificationsModal.module.scss';

interface IProp extends ModalProps {
  isModalOpen: boolean;
  handleCancel: VoidFunction;
  rejectedCount: number;
  approvedCount: number;
  schoolId: number;
}

export const SendNotificationsModal = ({
  isModalOpen,
  handleCancel,
  rejectedCount,
  approvedCount,
  schoolId,
}: IProp) => {
  const sendApiRequest = useApiRequest();

  const [sendNotifications, { isLoading: areNotificationsSending }] = useSendNotificationsMutation();

  const sendNotificationsHandle = () =>
    sendApiRequest({
      successMessage: 'Уведомления успешно отправлены',
      apiRequestCallback: () => sendNotifications({ schoolId }),
      successCallback: handleCancel,
    });

  return (
    <Modal
      width={600}
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
    >
      <Spin spinning={areNotificationsSending}>
        <div className={styles.wrapper}>
          <div className={styles['header-wrapper']}>
            <p className={styles.title}>Отправка уведомлений кандидатам</p>
            <p className={styles.description}>Подтвердите отправку уведомлений о принятых решениях</p>
          </div>
          <div className={styles['content-wrapper']}>
            <div className={styles['stat-wrapper']}>
              <Card className={cn(styles['stat-card'], styles['stat-card-approved'])}>
                <div className={styles['card-header']}>
                  <CheckOutlined className={styles['card-icon']} />
                  <p className={styles['card-title']}>Одобрено:</p>
                </div>
                <p className={styles['card-value']}>
                  {getRussianPluralForm(approvedCount, ['кандидат', 'кандидата', 'кандидатов'])}
                </p>
              </Card>
              <Card className={cn(styles['stat-card'], styles['stat-card-rejected'])}>
                <div className={styles['card-header']}>
                  <CloseOutlined className={styles['card-icon']} />
                  <p className={styles['card-title']}>Отклонено:</p>
                </div>
                <p className={styles['card-value']}>
                  {getRussianPluralForm(rejectedCount, ['кандидат', 'кандидата', 'кандидатов'])}
                </p>
              </Card>
            </div>
            <Card className={styles.annotation}>
              <p className={styles['annotation-text']}>
                <span className={styles['strong-text']}>Внимание:</span> Будут отправлены email-уведомления всем
                кандидатам с принятыми решениями. Одобренные кандидаты получат инструкции для следующего этапа,
                отклонённые — информацию о причинах отклонения.
              </p>
            </Card>
          </div>
          <div className={styles['buttons-wrapper']}>
            <Button onClick={handleCancel}>Отмена</Button>
            <Button
              icon={
                <SendOutlined
                  rotate={-45}
                  className={styles.icon}
                />
              }
              color="blue"
              variant="solid"
              disabled={areNotificationsSending}
              onClick={sendNotificationsHandle}
            >
              Отправить уведомления
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  );
};
